import { useEffect, useState } from 'react';
import paymentService from '../services/paymentService';

// Egyszer kérjük le alkalmazás-futásonként — a környezet beállítása futás közben nem változik
let cachedConfig = null;
let pendingRequest = null;

const DEFAULT_CONFIG = { barionEnabled: false, featuredPaymentEnabled: false, barionPixelId: null };

/**
 * Backendről érkező fizetési beállítások (GET /api/payments/config), hogy ugyanaz a frontend
 * build minden környezetben helyesen mutassa pl. a Barion fizetési módot.
 */
const usePaymentConfig = () => {
  const [config, setConfig] = useState(cachedConfig || DEFAULT_CONFIG);

  useEffect(() => {
    if (cachedConfig) return undefined;
    let active = true;
    if (!pendingRequest) {
      pendingRequest = paymentService.getConfig()
        .then(res => { cachedConfig = { ...DEFAULT_CONFIG, ...(res.data || {}) }; return cachedConfig; })
        .catch(() => DEFAULT_CONFIG)
        .finally(() => { pendingRequest = null; });
    }
    pendingRequest.then(result => { if (active) setConfig(result); });
    return () => { active = false; };
  }, []);

  return config;
};

/** Elfogad-e a szolgáltató Barion-fizetést (bekapcsolta, és admin ellenőrizte a tárcáját). */
export const providerAcceptsBarion = (provider) =>
  !!provider
  && (provider.paymentMethods || []).includes('BARION')
  && provider.barionStatus === 'VERIFIED';

export default usePaymentConfig;
